import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import cn from 'classnames';

import { EventBus } from '@catawiki/runtime-toolkit';
import { Button } from '@catawiki/cata-style';

import { isLoggedIn } from '@/shared/cookies';

import styles from './SignupButton.module.scss';

export const SignupButton: FC = () => {
  const { t } = useTranslation();

  if (isLoggedIn()) return null;

  const handleRegistrationClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    EventBus.showScreen({ screen: EventBus.Screen.SIGN_UP });
  };

  return (
    <>
      <nav
        suppressHydrationWarning
        className="c-header__links u-no-wrap u-hide-print"
      >
        <div className="c-header__links u-typography-h7 u-color-title-text">
          <Button
            data-testid="register-desktop"
            onClick={handleRegistrationClick}
          >
            {t('register_button')}
          </Button>
        </div>
      </nav>

      <div
        suppressHydrationWarning
        className="c-header__mobile-nav u-hide-m u-hide-l u-hide-print u-flex u-flex--align-items-center"
      >
        <Button
          data-testid="register-mobile"
          className={cn(styles.inline, styles.signup)}
          onClick={handleRegistrationClick}
        >
          {t('register_button')}
        </Button>
      </div>
    </>
  );
};

/** We use dynamic import for this component */
// eslint-disable-next-line import/no-default-export
export default SignupButton;
